import authApi from '@/core/api/modules/auth';

/*
 * The websocket server only delivers messages for topics a socket subscribed to. The admin app
 * subscribes to its studio:<studio_url> topic (page.generated, podcast.episode_converted), proven
 * with a ticket from GET /api/ws-ticket. Call subscribeSocket on every open, since a reconnect
 * gives a fresh socket with no subscriptions.
 */

// WebSocket.OPEN, spelled out so this also runs where WebSocket is not defined (unit tests)
const OPEN = 1;

type TicketLoader = () => Promise<WebsocketTicket>;

let subscribedTopics: string[] = [];

export async function subscribeSocket(
  socket: WebSocket | undefined,
  isLoggedIn: boolean,
  loadTicket: TicketLoader = authApi.getWebsocketTicket
): Promise<void> {
  if (!socket || !isLoggedIn) return;
  let ticket: WebsocketTicket;
  try {
    ticket = await loadTicket();
  } catch (error) {
    console.error('Could not load websocket ticket', error);
    return;
  }
  // the socket may have closed while the ticket was loading; its reconnect subscribes again
  if (socket.readyState !== OPEN || !ticket.topics.length) return;
  socket.send(
    JSON.stringify({
      action: 'subscribe',
      topics: ticket.topics,
      ticket: ticket.ticket,
    })
  );
  subscribedTopics = ticket.topics;
}

export function unsubscribeSocket(socket: WebSocket | undefined): void {
  if (socket && socket.readyState === OPEN && subscribedTopics.length) {
    socket.send(
      JSON.stringify({ action: 'unsubscribe', topics: subscribedTopics })
    );
  }
  subscribedTopics = [];
}
